import { v4 as uuidv4 } from "uuid";
import {
  LatestPaywallTraceProperties,
  getLatestPaywallTraceProperties,
  saveLatestPaywallTraceProperties,
} from "./paywallTraceStorage";
import { forceStartOpenPanelHighFidelitySessionReplay } from "./openpanel-client";

const PAYWALL_SURFACE = "subscription_upsell_paywall";
const PAYWALL_JOURNEY_SESSION_REPLAY_SAMPLE_RATE = 1;

type StartPaywallJourneyReplayParams = LatestPaywallTraceProperties & {
  replayStartReason: "predictive_signal" | "paywall_modal_trigger";
};

function getCurrentLocationProperties() {
  if (typeof window === "undefined") return {};

  return {
    paywallOpenedPathname: window.location.pathname,
    paywallOpenedSearch: window.location.search,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
  };
}

export async function startPaywallJourneyReplay({
  replayStartReason,
  ...paywallTraceProperties
}: StartPaywallJourneyReplayParams): Promise<LatestPaywallTraceProperties> {
  const existingPaywallTraceProperties = getLatestPaywallTraceProperties();
  const existingPaywallTraceId = existingPaywallTraceProperties.paywallTraceId;
  const nowIsoString = new Date().toISOString();

  const nextPaywallTraceProperties: LatestPaywallTraceProperties = {
    ...existingPaywallTraceProperties,
    ...paywallTraceProperties,
    ...getCurrentLocationProperties(),
    paywallTraceId: existingPaywallTraceId || uuidv4(),
    paywallSurface: PAYWALL_SURFACE,
    paywallReplaySampleRate: PAYWALL_JOURNEY_SESSION_REPLAY_SAMPLE_RATE,
    paywallReplayStartedAt: existingPaywallTraceProperties.paywallReplayStartedAt || nowIsoString,
    paywallReplayStartReason: existingPaywallTraceProperties.paywallReplayStartReason || replayStartReason,
  };

  if (replayStartReason === "predictive_signal") {
    nextPaywallTraceProperties.predictiveReplayStartedAt =
      existingPaywallTraceProperties.predictiveReplayStartedAt || nowIsoString;
  }

  saveLatestPaywallTraceProperties(nextPaywallTraceProperties);
  await forceStartOpenPanelHighFidelitySessionReplay().catch((replayStartError) => {
    console.error("[paywallReplayLifecycle] OpenPanel session-replay bump failed", replayStartError);
  });

  return nextPaywallTraceProperties;
}
